import Form from 'app/components/Form';

import {
  currencyOptions
} from 'app/utils/options';

import {
  OVERLAY_PRODUCT_TYPE
} from 'app/utils/Constants';

const JobConfigForm = props => {
  const {
    jobConfig,
    jobConfigTemplate,
    jobConfigTemplates,
    onClose,
    onSubmit,
    //onJobConfigFieldChange,
    onJobConfigTemplateChange,
    onPricingModelChange,
    action,
    lastUpdate
  } = props;

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  const productFields = ['pricing_model', 'stack_purchases', 'tax_percentage', 'price', 'discount'];
  const onCustomSubmit = async (params) => {
    let productParams = {};

    for (var field of productFields) {
      productParams[field] = params[field];
    }

    params.product = productParams;

    await onSubmit(params);
  }

  const jobConfigTemplateOptions = jobConfigTemplates.map(jct => {
    return {
      label: jct.name,
      value: jct.id
    }
  }).filter(opt => opt.value !== -1); // filter out Digital Delivery

  const pricingModelOptions = [
    { label: 'Basic', value: 0, helperText: 'Set a price per moment and a price for all' },
    { label: 'Volume', value: 2, helperText: 'Set volume-based discounts' },
    { label: 'Packages', value: 3, helperText: 'Setup quantity-based packages' }
  ]

  const currencyType = formState => {
    return formState.currency
  }

  const disableProductType = () => {
    return action !== 'create'
  }

  let fields = [
    { name: 'job_config_template_id', label: 'Product Type', type: 'select', value: jobConfigTemplate.id, valueType: 'integer', options: jobConfigTemplateOptions, hideNoneOption: true, disabled: disableProductType, helperText: 'Product to configure', onChange: onJobConfigTemplateChange },
    { name: 'name', label: 'Product name', type: 'text', value: jobConfig?.name, helperText: 'Product name that appears in dropdowns' },
    { name: 'client_id', label: 'Product ID', type: 'text', value: jobConfig?.client_id, helperText: 'Unique product ID (for use with the API)' },
  ]

  if (jobConfigTemplate?.product_type == OVERLAY_PRODUCT_TYPE) {
    fields.push({ name: 'hide_original', label: 'Hide originals?', type: 'checkbox', value: jobConfig?.hide_original, valueType: 'boolean', helperText: 'Determines whether the original uploaded photos are hidden' });
  }

  if (jobConfigTemplate?.selling_method > 0) {
    fields = fields.concat([
      { name: 'pricing_model', label: 'Pricing Model', type: 'select', value: jobConfig?.product?.pricing_model, valueType: 'integer', options: pricingModelOptions, hideNoneOption: true, helperText: 'Setup quantity-based packages', onChange: onPricingModelChange },
      { name: 'stack_purchases', label: 'Stack purchases?', type: 'checkbox', valueType: 'boolean', value: jobConfig?.product?.stack_purchases },
      { name: 'tax_percentage', label: 'Tax Percentage', type: 'currency', valueType: 'number', value: jobConfig?.product?.tax_percentage, currency: 'percentage' },
      { name: 'currency', label: 'Currency', type: 'select', value: jobConfig?.currency, valueType: 'string', options: currencyOptions, hideNoneOption: true, helperText: 'The customer will be billed in this currency' },
      { name: 'price', label: 'Standard Value', type: 'currency', valueType: 'number', value: jobConfig?.product?.price, helperText: 'Standard price per moment', currency: currencyType },
      { name: 'discount', label: 'Discounted Price for All', type: 'currency', valueType: 'number', value: jobConfig?.product?.discount, helperText: 'Price for all moments', currency: currencyType }
    ]);
  }

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      //onChange: onJobConfigFieldChange,
      onSubmit: onCustomSubmit,
      lastUpdate
    }} />
  );
}

export default JobConfigForm;
